<template>
    <asli-popup :show-close-button="false" v-model="displayModal" class="p-4" header="Session Timeout Warning">
        <div class="px-8 py-4">
            <p>
                Your session will expire in <span id="timer">{{ countdown }}</span> Do you want to extend the session?
            </p>
        </div>
        <asli-divider class="mt-4" />
        <div class="px-4 py-4 flex gap-x-2 justify-end flex-col xs:flex-row gap-y-2 xs:gap-y-0">
            <asli-button id="extend-session" color="primary" @click="handleOk">Continue Session</asli-button>
            <asli-button id="close-warning" color="secondary" @click="handleCancel">End Session</asli-button>
        </div>
    </asli-popup>
</template>

<script lang="ts" setup>
import { endSession, resetTimer } from "@/hooks/session-expired";
import { useMainStore } from "@/stores/main";
import { AsliPopup, AsliButton, AsliDivider } from "@mbs-npm/anpost-ui";
import { computed, ref, watch } from "vue";

defineProps({
    header: {
        type: String,
        default: null
    }
});
const mainStore = useMainStore();

let timer;
let countSeconds = ref(60);
let countMinutes = ref(1);

const countdown = computed(() => {
    if (countMinutes.value === 1 && countSeconds.value === 60) {
        return `2 minutes.`;
    } else if (countMinutes.value === 0 && countSeconds.value === 60) {
        return `1 minute.`;
    }
    return `
    ${countMinutes.value === 1 ? `${countMinutes.value} minute` : ""} ${countSeconds.value} second${
        countSeconds.value === 1 ? "" : "s"
    }.
    `;
});

const displayModal = computed({
    get: () => mainStore.sessionExpiry.showTimeoutModal,
    set: val => (mainStore.sessionExpiry.showTimeoutModal = val)
});

watch(displayModal, newVal => {
    if (newVal === true) {
        timer = setInterval(function () {
            countSeconds.value--;
            if (countSeconds.value === 0) {
                if (countMinutes.value === 1) {
                    countMinutes.value--;
                    countSeconds.value = 60;
                } else if (countMinutes.value === 0) {
                    endSession();
                }
            }
        }, 1000);
    } else {
        countSeconds.value = 60;
        countMinutes.value = 1;
        clearInterval(timer);
    }
});

function handleOk() {
    displayModal.value = false;
    resetTimer();
}

function handleCancel() {
    endSession();
}
</script>
